// Single icon catalogue. Provenance and hashes: icon-assets.manifest.json.
import add from '../../assets/icons/actions/add.svg';
import arrowDown from '../../assets/icons/actions/arrow-down.svg';
import attached from '../../assets/icons/actions/attached.svg';
import checkCircle from '../../assets/icons/actions/check-circle.svg';
import crossCircle from '../../assets/icons/actions/cross-circle.svg';
import deleteIcon from '../../assets/icons/actions/delete.svg';
import download from '../../assets/icons/actions/download.svg';
import edit from '../../assets/icons/actions/edit.svg';
import filterAction from '../../assets/icons/actions/filter.svg';
import notes from '../../assets/icons/actions/notes.svg';
import ownership from '../../assets/icons/actions/ownership.svg';
import password from '../../assets/icons/actions/password.svg';
import powerOff from '../../assets/icons/actions/power-off.svg';
import preview from '../../assets/icons/actions/preview.svg';
import reset from '../../assets/icons/actions/reset.svg';
import save from '../../assets/icons/actions/save.svg';
import upload from '../../assets/icons/actions/upload.svg';
import bell from '../../assets/icons/actions/bell.svg';
import calendar from '../../assets/icons/nav/calendar.svg';
import clients from '../../assets/icons/nav/clients.svg';
import completed from '../../assets/icons/status/completed.svg';
import config from '../../assets/icons/actions/config.svg';
import dashboard from '../../assets/icons/nav/dashboard.svg';
import pending from '../../assets/icons/status/pending.svg';
import document from '../../assets/icons/nav/document.svg';
import documentsSigned from '../../assets/icons/status/documents-signed.svg';
import finance from '../../assets/icons/nav/finance.svg';
import folder from '../../assets/icons/overview/folder.svg';
import inProgress from '../../assets/icons/status/in-progress.svg';
import loss from '../../assets/icons/metrics/loss.svg';
import logout from '../../assets/icons/actions/logout.svg';
import mail from '../../assets/icons/actions/mail.svg';
import menu from '../../assets/icons/actions/menu.svg';
import note from '../../assets/icons/overview/note.svg';
import phone from '../../assets/icons/actions/phone.svg';
import profit from '../../assets/icons/metrics/profit.svg';
import triangleWarning from '../../assets/icons/status/triangle-warning.svg';
import review from '../../assets/icons/status/review.svg';
import search from '../../assets/icons/actions/search.svg';
import sackDollar from '../../assets/icons/nav/sack-dollar.svg';
import settings from '../../assets/icons/nav/settings.svg';
import suppliers from '../../assets/icons/nav/suppliers.svg';
import taskIcon from '../../assets/icons/nav/task-icon.svg';
import team from '../../assets/icons/nav/team.svg';
import usdCircle from '../../assets/icons/metrics/usd-circle.svg';
import user from '../../assets/icons/overview/user.svg';
import users from '../../assets/icons/nav/users.svg';
import coins from '../../assets/icons/nav/coins.svg';
import filterDecoration from '../../assets/icons/actions/filter-decoration.svg';
import dealsProposals from '../../assets/icons/nav/deals.svg';
import dealsActive from '../../assets/icons/nav/deals-in-progess.svg';
import dealsCompleted from '../../assets/icons/nav/deals-completed.svg';

export const iconCatalog = {
  triangleWarning,
  add,
  arrowDown,
  attached,
  bell,
  calendar,
  clients,
  coins,
  completed,
  checkCircle,
  completedAction: completed,
  config,
  crossCircle,
  dashboard,
  pending,
  dealsProposals,
  dealsActive,
  dealsCompleted,
  delete: deleteIcon,
  document,
  documentsSigned,
  download,
  edit,
  finance,
  filter: filterAction,
  folder,
  filterDecoration,
  inProgress,
  loss,
  logout,
  mail,
  menu,
  note,
  notes,
  ownership,
  password,
  phone,
  powerOff,
  preview,
  profit,
  reset,
  review,
  save,
  search,
  settings,
  sackDollar,
  suppliers,
  taskIcon,
  team,
  usdCircle,
  user,
  users,
  upload
};

